import React from 'react'
import { isNotAcceptStyle } from '../../libs/isAcceptStyle'

/**
 *
 * @param {object} props
 * @param {React.ReactElement} props.children
 * @param {object=} props.top
 * @param {object=} props.right
 * @param {object=} props.bottom
 * @param {object=} props.left
 */
export const Margin = ({ children, top, right, bottom, left }) => {
  if (isNotAcceptStyle(children)) {
    return children
  }

  const elementStyle = children.props.style || {}
  const style = {
    ...elementStyle,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
  }

  return React.cloneElement(children, { style })
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/elements/Margin/index.js